import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import { Nullish } from '@/shared/utils/typescript';
import Location, { Coordinates } from '../models/Location';

export function parseLocation(data: any): Location | null {
  const [description, coordinates] = (data.location ?? data.objectLocation ?? data.stockLocation)?.split?.('|') ?? [];
  if (!description && !coordinates) return null;
  const location = new Location();
  if (description) location.description = description;
  if (coordinates) location.coordinates = parseCoordinates(coordinates);
  location.modifiedOn = parseMoment(data.locationModifiedOn);
  location.modifiedBy = User.withFullName(data.locationModifiedBy);
  return location;
}

export function formatLocation(location: Nullish<Location>): string {
  if (!location) return '';
  return `${location.description || ''}|${formatCoordinates(location.coordinates)}`;
}

export function parseCoordinates(data: Nullish<string>): Coordinates | null {
  if (!data) return null;
  const [lat, lng] = data.split(',').map(Number);
  return new Coordinates(lat, lng);
}

function formatCoordinates(coordinates: Nullish<Coordinates>): string {
  if (!coordinates) return '';
  return `${coordinates.latitude},${coordinates.longitude}`;
}
